export interface GpdrInfoRedirectInputData {
  redirectUrl: string;
}
